import { getBusiness, getServices } from '@/lib/features/data';

/**
 * Check if a business needs onboarding.
 * Uses an explicit onboarding_completed flag in the database.
 * Fallback: If flag is missing (old data), use heuristics.
 */
export async function needsOnboarding(businessId: string | null): Promise<boolean> {
  if (!businessId) {
    return true;
  }

  try {
    const business = await getBusiness(businessId);

    if (business?.onboarding_completed === true) {
      return false;
    }

    if (business?.onboarding_completed === false) {
      return true;
    }

    const services = await getServices(businessId);

    if (!business?.name || business.name.trim().length < 3) {
      return true;
    }

    if (services.length === 0) {
      return true;
    }

    return false;
  } catch {
    return true;
  }
}
